import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import { Mutations } from "@/store/enums/StoreEnums";
import { Pages } from "@/store/enums/StoreEnums";
import UserService from "@/core/services/UserService";
import store from "@/store";
import { useBanStore } from "@/store/pinia/BanModule";
import { useRouteStore } from "@/store/pinia/RouteModule";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        meta: { auth: true },
        name: "dashboard",
        component: () => import("@/views/DashboardPage.vue"),
      },
      {
        path: "/search",
        meta: { auth: true },
        name: "search.page",
        component: () => import("@/views/SearchPage.vue"),
      },
      {
        path: "/categories/:categoryId/items/:itemId",
        meta: { auth: true, group: "category" },
        name: "item.categories.items.show",
        component: () => import("@/views/items/ItemForm.vue"),
      },
      {
        path: "/categories/:categoryId/:type",
        meta: { auth: true, group: "category" },
        name: "item.categories.form",
        component: () => import("@/views/items/CategoryForm.vue"),
      },
      {
        path: "/categories",
        meta: { auth: true, group: "category" },
        name: "item.categories",
        component: () => import("@/views/items/CategoryList.vue"),
      },

      {
        path: "/categories/search",
        meta: { auth: true, group: "category" },
        name: "item.search",
        component: () => import("@/views/items/SearchForm.vue"),
      },
      {
        path: "/categories/:categoryId",
        meta: { auth: true, group: "category" },
        name: "item.categories.detail",
        component: () => import("@/views/items/CategoryList.vue"),
      },
      {
        path: "/skills",
        meta: { auth: true, group: "skills" },
        name: "skills.list",
        component: () => import("@/views/skills/SkillPackList.vue"),
      },
      {
        path: "/territories",
        meta: { auth: true, group: "territory" },
        name: "territories.list",
        component: () => import("@/views/territories/TerritoryList.vue"),
      },
      {
        path: "/territories/:categoryId",
        meta: { auth: true, group: "territory" },
        name: "territories.detail",
        component: () => import("@/views/territories/TerritoryShow.vue"),
      },
      {
        path: "/territories/:categoryId/:itemId",
        meta: { auth: true, group: "territory" },
        name: "territories.place.detail",
        component: () => import("@/views/territories/PlaceShow.vue"),
      },
      /** @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */
      /*{
        path: "/units",
        meta: { auth: true, group: "units" },
        name: "item.units.list",
        component: () => import("@/views/territories/TerritoryList.vue"),
      },*/
      {
        path: "/units/monsters/",
        meta: { auth: true, group: "units" },
        name: "units.monsters.list",
        component: () => import("@/views/units/MonsterList.vue"),
      },
      {
        path: "/units/npc/",
        meta: { auth: true, group: "units" },
        name: "units.npc.list",
        component: () => import("@/views/units/NPCList.vue"),
      },
      {
        path: "/units/:itemId",
        meta: { auth: true, group: "units" },
        name: "units.monsters.detail",
        component: () => import("@/views/units/UnitDetail.vue"),
      },
      /** @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */

      {
        path: "/syncs/lang",
        name: "syncs.lang",
        meta: { auth: true },
        component: () => import("@/views/syncs/LangPage.vue"),
      },
      {
        path: "/syncs/area-mask",
        name: "syncs.area.mask",
        meta: { auth: true },
        component: () => import("@/views/syncs/AreaMaskPage.vue"),
      },
      {
        path: "/syncs/map-info",
        name: "syncs.map.info",
        meta: { auth: true },
        component: () => import("@/views/syncs/MapInfoPage.vue"),
      },
      {
        path: "/syncs/gui",
        name: "syncs.gui",
        meta: { auth: true },
        component: () => import("@/views/syncs/GuiPage.vue"),
      },
      {
        path: "/syncs/recipes",
        name: "syncs.recipes",
        meta: { auth: true },
        component: () => import("@/views/syncs/RecipesPage.vue"),
      },
      {
        path: "/syncs/database",
        name: "syncs.database",
        meta: { auth: true },
        component: () => import("@/views/syncs/DatabasePage.vue"),
      },
      {
        path: "/syncs/items/resources",
        name: "syncs.items.resources",
        meta: { auth: true },
        component: () => import("@/views/syncs/ItemResourcePage.vue"),
      },
      {
        path: "/syncs/info.dat",
        name: "syncs.info.dat",
        meta: { auth: true },
        component: () => import("@/views/syncs/InfoDatPage.vue"),
      },
      {
        path: "/settings/properties/items",
        name: "settings.properties.items",
        meta: { auth: true },
        component: () => import("@/views/settings/PropertiesPage.vue"),
      },
      {
        path: "/settings/user",
        name: "settings.user",
        meta: { auth: true },
        component: () => import("@/views/settings/UserSettingsPage.vue"),
      },
      {
        path: "/settings/character-classes",
        name: "settings.character-classes.list",
        meta: { auth: true },
        component: () =>
          import("@/views/settings/character-classes/CharacterClassList.vue"),
      },
      {
        path: "/settings/character-classes/:id",
        name: "settings.character-classes.detail",
        meta: { auth: true },
        component: () =>
          import("@/views/settings/character-classes/CharacterClassDetail.vue"),
      },
      {
        path: "/settings/handbooks",
        alias: ["/settings/collections"],
        name: "settings.handbooks",
        meta: { auth: true },
        component: () => import("@/views/settings/HandbookPage.vue"),
      },
      {
        path: "/library/quests/categories",
        meta: { auth: true, group: "quests" },
        name: "quests.categories",
        component: () => import("@/views/library/quests/CategoryList.vue"),
      },
      {
        path: "/library/quests/categories/search",
        meta: { auth: true, group: "quests" },
        name: "quests.search",
        component: () => import("@/views/library/quests/SearchForm.vue"),
      },
      {
        path: "/library/quests/categories/:categoryId/items/:itemId",
        meta: { auth: true, group: "quests" },
        name: "quests.categories.quests.show",
        component: () => import("@/views/library/quests/QuestForm.vue"),
      },
      {
        path: "/library/quests/categories/:categoryId/:type",
        meta: { auth: true, group: "quests" },
        name: "quests.categories.form",
        component: () => import("@/views/library/quests/CategoryForm.vue"),
      },
      {
        path: "/library/quests/categories/:categoryId",
        meta: { auth: true, group: "quests" },
        name: "quests.categories.detail",
        component: () => import("@/views/library/quests/CategoryList.vue"),
      },
      {
        path: "/library/news/",
        meta: { auth: true, group: "news" },
        name: "news.list",
        component: () => import("@/views/library/news/NewsList.vue"),
      },
      {
        path: "/library/news/add",
        meta: { auth: true, group: "news" },
        name: "news.create",
        component: () => import("@/views/library/news/NewsForm.vue"),
      },
      {
        path: "/library/news/:itemId/:type",
        meta: { auth: true, group: "news" },
        name: "news.detail",
        component: () => import("@/views/library/news/NewsForm.vue"),
      },
      {
        path: "/library/events/",
        meta: { auth: true, group: "events" },
        name: "events.list",
        component: () => import("@/views/library/events/EventList.vue"),
      },
      {
        path: "/library/events/add",
        meta: { auth: true, group: "events" },
        name: "events.create",
        component: () => import("@/views/library/events/EventForm.vue"),
      },
      {
        path: "/library/events/:itemId/:type",
        meta: { auth: true, group: "events" },
        name: "events.detail",
        component: () => import("@/views/library/events/EventForm.vue"),
      },
      {
        path: "/library/guides/tags",
        meta: { auth: true, group: "guides" },
        name: "guides.tags",
        component: () => import("@/views/library/guides/GuideTagsPage.vue"),
      },
      {
        path: "/library/guides/categories/:categoryId/guides/:itemId/:type",
        meta: { auth: true, group: "guides" },
        name: "guides.guide.form",
        component: () => import("@/views/library/guides/GuideForm.vue"),
      },
      {
        path: "/library/guides",
        meta: { auth: true, group: "guides" },
        name: "guides.root",
        component: () => import("@/views/library/guides/CategoryList.vue"),
      },
      {
        path: "/library/guides/categories",
        meta: { auth: true, group: "guides" },
        name: "guides.categories",
        component: () => import("@/views/library/guides/CategoryList.vue"),
      },
      {
        path: "/library/guides/categories/:categoryId/:type",
        meta: { auth: true, group: "guides" },
        name: "guides.categories.form",
        component: () => import("@/views/library/guides/CategoryForm.vue"),
      },
      {
        path: "/library/guides/categories/:categoryId",
        meta: { auth: true, group: "guides" },
        name: "guides.categories.detail",
        component: () => import("@/views/library/guides/CategoryList.vue"),
      },
    ],
  },

  {
    path: "/",
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        meta: { auth: false },
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
      },
      {
        path: "/sign-up",
        name: "sign-up",
        meta: { auth: false },

        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignUp.vue"),
      },
      {
        path: "/password-reset",
        name: "password-reset",
        meta: { auth: false },

        component: () =>
          import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
      },
    ],
  },

  {
    path: "/banned",
    name: "banned",
    meta: { auth: false },
    component: () => import("@/views/crafted/authentication/BannedPage.vue"),
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/crafted/authentication/Error500.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.afterEach(async (r) => {
  const pinia = useRouteStore();
  //if (Object.keys(r.params).length > 0) {
  pinia.setRouteParams(r.params);
  //}
});

router.beforeEach(async (r) => {
  const pinia = useRouteStore();
  const banStore = useBanStore();

  if (banStore.hasBan() && r.name !== Pages.BANNED) {
    return router.push({ name: Pages.BANNED });
  }

  const auth =
    typeof r.meta.auth !== "undefined" ? !(r.meta.auth === false) : true;

  if (auth) {
    if (!UserService.hasToken() || UserService.getUser().id === 0) {
      router.push({ name: "sign-in" }).then(() => {
        console.warn("not auth", UserService.getUser());
      });
    }
  }

  if (
    (r.name === Pages.LOGIN || r.name === Pages.REGISTER) &&
    UserService.hasToken() &&
    UserService.getUser().id > 0
  ) {
    await router.push({ name: "dashboard" });
  }

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
